module.exports = __webpack_public_path__ + "static/media/cover.d1b7048c.png";